export class FacilityProfile {
  constructor(
    readonly name: string,
    readonly imageUrl: string,
    readonly updatedAt: string,
    readonly url: string,
  ) {}
}
